import React, { useRef, useState } from "react";

export default props => {
    const [iFrameHeight, setIFrameHeight] = useState(0);
    const ref = useRef();
    return (
        <iframe
            title={props.src}
            style={{ width: "100%", height: iFrameHeight, overflow: "visible" }}
            onLoad={() =>
                window.setInterval(() => {
                    if (ref.current) setIFrameHeight(ref.current.contentWindow.document.body.scrollHeight);
                }, 100)
            }
            ref={ref}
            src={props.src}
            width="100%"
            height={iFrameHeight}
            scrolling="no"
            frameBorder="0"
        />
    );
};
